/* unplugin-vue-components disabled */import { render } from "./popupBottom.vue?vue&type=template&id=0a612f9d&scoped=true"
import script from "./popupBottom.vue?vue&type=script&lang=js"
export * from "./popupBottom.vue?vue&type=script&lang=js"

import "./popupBottom.vue?vue&type=style&index=0&id=0a612f9d&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a612f9d"]])

export default __exports__